import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { environment } from 'src/environments/environment';
import { HttperrorhandlerService } from './../shared/http/httperrorhandler.service';

@Injectable({
  providedIn: 'root'
})
export class LandingPageService {

  startCarousel: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  throbberRunningStatus = {
    throbberAR: true,
    throbberFR: true,
    throbberFW: true,
    throbberHW: true,
    throbberFF: true
  };

  [x: string]: any;
  mandalData: object;
  baseUrl: string = ProjConstants.API_URL_TEMP;
  API_MAPPING: object = ProjConstants.API_MAPPING;
  kaleshwaramStagingUrl: any;
  apwrimsAPIUrl: any;

  constructor(
    private http: HttpClient,
    private utils: UtilsService,
    private errorHandler: HttperrorhandlerService
  ) {
    this.baseUrl = ProjConstants.API_URL_TEMP;
    this.apwrimsAPIUrl = environment.url.APWRIMS_STAGING_API_URL;
    this.API_MAPPING = ProjConstants.API_MAPPING;
    this.kaleshwaramStagingUrl = environment.url.KALESHWARAM_API_URL;
  }

  getHeaders() {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return headers;
  }

  TestCall(api: string, postData: any): Observable<any> {
    const apiStatus: any = this.isValidAPICall(api);
    // if (!!apiStatus.valid) {
    //   console.log('rainfall1',this.baseUrl + '' + apiStatus.api)
    //   console.log('rainfall2',postData)
    //   return this.http.post(this.baseUrl + '' + apiStatus.api, postData, { headers: this.getHeaders() });
    // } else {
    //   return throwError({ status: false, msg: apiStatus.msg });
    // }  return this.http.post<Hero>(this.heroesUrl, hero, httpOptions)
    // .pipe(
    //   catchError(this.handleError('addHero', hero))
    // );
    return this.http.post<any>(this.baseUrl + '' + apiStatus.api, postData).pipe(
      catchError(this.errorHandler.handleError('All Sources data for Components : ', []))
    );
  }

  getfloodForecastRiverData(): Observable<any> {
    // return this.http.get<any>("https://forecast-staging.vassarlabs.com/apwrimsgeo/geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=VASSARLABS:flood_forecast_river_links_v8&maxFeatures=5000000&outputFormat=application%2Fjson")
    return this.http.get<any>(environment.url.KLWSGEOSERVER_URL+"ows?service=WFS&version=1.0.0&request=GetFeature&typeName=flood_forecast_river_links_v8_20210524&maxFeatures=5000000&outputFormat=application%2Fjson")
  }

  getfloodForecastPointData(): Observable<any> {
    return this.http.get<any>(this.apwrimsAPIUrl + 'flowmanagement/maxdata/root/3a7a18ff-8614-4c90-aa98-451b333df3d9/hourLimit/0/24');
  }

  // getForecastRainfallmm(api: string): Observable<any> {
  //   const rainfallParams={"primarySource":"ECMWF","secondarySource":"null","view":"Admin","sUUID":"2b9beab2-1495-4f05-b4da-29761ebeb2ee","component":"RAINFALL","locationType":"BLOCK","forecastLength":"10","pUUID":"2b9beab2-1495-4f05-b4da-29761ebeb2ee","pType":"STATE","cType":"BLOCK"}
  //   const apiStatus: any = this.isValidAPICall(api);
  //   if (!!apiStatus.valid) {
  //     return this.http.post(this.baseUrl + '' + apiStatus.api, rainfallParams, { headers: this.getHeaders() });
  //   } else {
  //     return throwError({ status: false, msg: apiStatus.msg });
  //   }

  // }

  getTableData(params): Observable<any> {
    return this.http.post(this.baseUrl + 'weatherForecast/getTableData', params, { headers: this.getHeaders() });
  }

  makePostApiCall(api: string, postData: any): Observable<any> {
    const apiStatus: any = this.isValidAPICall(api);
    if (!!apiStatus.valid) {
      return this.http.post(this.baseUrl + '' + apiStatus.api, postData, { headers: this.getHeaders() });
    } else {
      return throwError({ status: false, msg: apiStatus.msg });
    }
  }

  getHeatWaveData(url, postData) {
    const promise = new Promise((resolve, reject) => {
      this.http.post(ProjConstants.API_URL + url, postData).subscribe(data => {
        this.mandalData = data;
        resolve(data);
      },
        err => {
          reject(err);
        }
      );
    });
    return promise;
  }

  formatDistrictData(data) {
    const finalData = {};
    const timeStampList = [];
    const tableData = [];
    for (const locName in data) {
      if (!isNullOrUndefined(locName)) {
        const locObject = {};
        locObject['District'] = { val: this.utils.formatNames(data[locName]['name']) };
        for (const element in data[locName]['table_data']) {
          if (isNullOrUndefined(data[locName]['table_data'][element]['data'])) {
            continue;
          }
          const timeStamp = data[locName]['table_data'][element]['timeStamp'];
          if (!timeStampList.includes(timeStamp)) {
            timeStampList.push(timeStamp);
          }
          const timeC = timeStamp.toString() + '_' + 'c';
          locObject[timeC] = { val: data[locName]['table_data'][element]['data']['c'] };
          const timeD = timeStamp.toString() + '_' + 'd';
          locObject[timeD] = { val: data[locName]['table_data'][element]['data']['d'] };
        }
        if (!isNullOrUndefined(data[locName]['centroid'])) {
          locObject['centroid'] = data[locName]['centroid'];
        }
        tableData.push(locObject);
      }
    }
    const sortedTimeStampList = timeStampList.sort();
    const column1 = [];
    column1.push({
      val: 'District',
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: 'District',
    });
    const column2 = [];
    const tableHeaders = [];
    tableHeaders.push({ val: 'District' });
    for (const index in sortedTimeStampList) {
      if (!isNullOrUndefined(index)) {
        const tp = sortedTimeStampList[index];
        column1.push({
          val: this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
          colspan: 2,
          rowspan: 1,
          sortedHeaderVal: tp.toString() + '_d'
        });
        column2.push({
          val: 'C',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
          sortedHeaderVal: tp.toString() + '_c'
        });
        column2.push({
          val: 'D',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
          sortedHeaderVal: tp.toString() + '_d'
        });
        tableHeaders.push({
          val: tp.toString() + '_c'
        });
        tableHeaders.push({
          val: tp.toString() + '_d'
        });
      }
    }
    const tableColumns = [];
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = tableData;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatChartData(data, chartDataString) {
    const timeStampList = [];
    const blockArray = [];
    const formattedChartData = [{}, {}, {}];
    formattedChartData[0][chartDataString] = 'SevereHeatwave';
    formattedChartData[1][chartDataString] = 'Heatwave';
    formattedChartData[2][chartDataString] = 'Normal';
    const chartData = {
      SevereHeatwave: {},
      Heatwave: {},
      Normal: {}
    };
    for (const locName in data) {
      if (!isNullOrUndefined(locName)) {
        for (const element in data[locName]['table_data']) {
          if (!isNullOrUndefined(element)) {
            if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
              continue;
            }
            const timeStamp = data[locName]['table_data'][element]['timeStamp'];
            if (!timeStampList.includes(timeStamp)) {
              timeStampList.push(timeStamp);
            }
            const date = this.utils.convertModelDatetoDate(timeStamp).toLocaleDateString();
            if (chartData['SevereHeatwave'][date] == undefined && formattedChartData[0][date] == undefined) {
              chartData['SevereHeatwave'][date] = data[locName]['table_data'][element]['data']['d'];
              formattedChartData[0][date] = data[locName]['table_data'][element]['data']['d'];
            } else {
              chartData['SevereHeatwave'][date] += data[locName]['table_data'][element]['data']['d'];
              formattedChartData[0][date] += data[locName]['table_data'][element]['data']['d'];
            }
            if (chartData['Heatwave'][date] == undefined && formattedChartData[1][date] == undefined) {
              chartData['Heatwave'][date] = data[locName]['table_data'][element]['data']['c'];
              formattedChartData[1][date] = data[locName]['table_data'][element]['data']['c'];
            } else {
              chartData['Heatwave'][date] += data[locName]['table_data'][element]['data']['c'];
              formattedChartData[1][date] += data[locName]['table_data'][element]['data']['c'];
            }
            if (chartData['Normal'][date] == undefined && formattedChartData[2][date] == undefined) {
              chartData['Normal'][date] = data[locName]['table_data'][element]['data']['n'];
              formattedChartData[2][date] = data[locName]['table_data'][element]['data']['n'];
            } else {
              chartData['Normal'][date] += data[locName]['table_data'][element]['data']['n'];
              formattedChartData[2][date] += data[locName]['table_data'][element]['data']['n'];
            }
          }
        }
      }
    }
    const sortedTimeStampList = timeStampList.sort();
    for (const tp of sortedTimeStampList) {
      blockArray.push(this.utils.convertModelDatetoDate(tp).toLocaleDateString());
    }
    return [chartData, formattedChartData, blockArray];
  }

  isValidAPICall(api: string): object {
    if (!isNullOrUndefined(this.API_MAPPING)) {
      const currentApi = this.API_MAPPING[api];
      if (!isNullOrUndefined(currentApi)) {
        return { valid: true, api: currentApi };
      } else {
        console.log('API_MAPPING not found for for ' + api + '..Please update API_MAPPING in projconstants');
        return { valid: false, msg: 'API_MAPPING not found for ' + api };
      }
    } else {
      console.log('API_MAPPING not found in projconstants');
      return { valid: false, msg: 'API_MAPPING not found in projconstants' };
    }
  }

  setChartData(data, projConstants) {
    const keys = Object.keys(data);
    const formattedChartData = [];
    for (const key of keys) {
      const obj = {};
      for (const item of Object.keys(data[key])) {

        if (item == '6hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[key][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        }
      }
      obj[projConstants.CHART_DATA_COLUMNS['RAINFALL']] = key;
      formattedChartData.push(obj);
    }
    return formattedChartData;
  }

  formatDataForChart(data) {
    const chartData = {};
    for (const range of Object.keys(data)) {
      const obj = {};
      for (const item of Object.keys(data[range])) {
        if (item == '6hr') {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[range][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[range][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[range][item][timestamp];
          }
        }
      }
      chartData[range] = obj;
    }
    return chartData;
  }

  convertTimestampToBlockValue(inputts: any, forecstLength?: any) {
    const ts = Number(inputts);
    const millisInSixHours = ProjConstants.MILLIS_IN_6HOURS;
    if (forecstLength== '24') {
      let hours = new Date(ts).getHours();
      let minutes = new Date(ts).getMinutes();
      let string = hours.toString() + ':' + minutes.toString();
      hours = new Date(ts + millisInSixHours).getHours();
      minutes = new Date(ts + millisInSixHours).getMinutes();
      const string1 = hours.toString() + ':' + minutes.toString();
      return string.toString() + '-' + string1.toString();
    } else if (forecstLength== '10') {
      const date = new Date(ts).toLocaleDateString();
      return date;
    } else if (forecstLength== 'weekly') {
      const date = new Date(ts).toLocaleDateString();
      return date;
    }
    else {
      return inputts;
    }
  }

  getWebEocThresholds(): Observable<any>{
    // https://forecast.vassarlabs.com/api/webeoc/getwebeoctresholds
    return this.http.get<any>('https://forecast.vassarlabs.com/api/webeoc/getwebeoctresholds').pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  setWebEocThresholds(pData:any): Observable<any>{
    // https://forecast.vassarlabs.com/api/webeoc/getwebeoctresholds
    return this.http.post<any>('https://forecast.vassarlabs.com/api/webeoc/setwebeoctresholds',pData).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }
  getWeatherOutlookDownload(): Observable<any>{
    return this.http.get<any>('https://forecast.vassarlabs.com/api/weatherForecast/getWeatherOutlookReport/weather_outlook',{ responseType: 'blob' as 'json' }).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

getDailyForecastDownload(): Observable<any>{
  return this.http.get<any>('https://forecast.vassarlabs.com/api/WeatherForecast/getTodayForecastReport/forecast',{ responseType: 'blob' as 'json' }).pipe(
    catchError(this.errorHandler.handleError('Kpi data request', []))
  );
}

  // getKpiData(options: object): Observable<any> {
  //   return this.http.post<any>(environment.url.PLAY_URL + 'rf/rfTable', options).pipe(
  //     catchError(this.errorHandler.handleError('Kpi data request', []))
  //   );
  // }

  getThunderstormData(options: object): Observable<any> {
    return this.http.post<any>(environment.url.HEATWAVE_STAGING_API_URL + 'weatherForecast/getChartData', options).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getNowcastChartData(options: object): Observable<any> {
    return this.http.post<any>(environment.url.HEATWAVE_STAGING_API_URL + 'nowcast/getChartData', options).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getWindSpeedChartData(options: object): Observable<any> {
    return this.http.post<any>(environment.url.HEATWAVE_STAGING_API_URL + 'weatherForecast/getChartData', options).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getObservedRainfallChartData(postData) {
    let url = environment.url.HEATWAVE_STAGING_API_URL + "rf/getObserveChartData";
    return this.http.post<any>(url, postData)
  }

  getRainfallForecastChartData(postData){
    let url = environment.url.HEATWAVE_STAGING_API_URL + "weatherForecast/getChartData";
    return this.http.post<any>(url, postData)
  }
}
